/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { Flex, FormControl, useToast } from '@chakra-ui/react'
import { MdClose } from 'react-icons/md'
import Modal from 'react-modal'
import { WhiteModal } from './styles'
import { InputCmp } from '../../../../../components/InputCmp'
import { CheckboxCmp } from '../../../../../components/CheckboxCmp'
import { useState } from 'react'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { appApi } from '../../../../../services/appApi'
import LoadingContainer from '../../../../../components/LoadingContainer'

interface iModalProps {
  isOpen: boolean
  onClose: () => void
  onSuccess: () => void
}

export const ModalDissidio: React.FC<iModalProps> = ({
  isOpen,
  onClose,
  onSuccess
}) => {
  const toast = useToast()
  const [IsLoading, setIsLoading] = useState(false)
  const [DataDissidioOn, setDataDissidioOn] = useState(false)
  const [Dissidio, setDissidio] = useState(0)
  const [DataDissidio, setDataDissidio] = useState('')

  function onPostDissidio(): void {
    setIsLoading(true)

    appApi.post(`api/CargosESalarios/Dissidio?dissidio=${Dissidio ?? 0}&dataDissidio=${DataDissidioOn ? (DataDissidio ?? '') : ''}`)
      .then((res) => {
        onSuccess()
        toast({
          title: 'Dissídio aplicado com sucesso',
          duration: 4000,
          position: 'top',
          status: 'success'
        })
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName="react-modal-overlay"
      className="react-modal-content-default"
    >
      <WhiteModal style={{ width: '46rem', maxHeight: '95vh', overflowY: 'auto' }}>
        <LoadingContainer loading={IsLoading} linhas={18}>
          <FormControl as={Flex} flexDir="column" gap="1rem">
            <Flex justifyContent="space-between">
              <h3
                style={{
                  fontSize: '20px',
                  fontWeight: 'bold',
                  color: 'var(--Azul)'
                }}
              >
                Aplicar dissídio
              </h3>
              <Flex color="var(--Red)" _hover={{ color: 'var(--Red-hover)' }}>
                <MdClose cursor="pointer" size={18} onClick={onClose} />
              </Flex>
            </Flex>

            <Flex flexDir={'column'} gap={'1rem'}>
              <InputCmp value={Dissidio} OnChange={(val) => setDissidio(parseFloat(val))} type='number' label='Informe a porcentagem do dissídio a ser aplicado' min={0}/>
              <CheckboxCmp isChecked={DataDissidioOn} OnChange={setDataDissidioOn}>Habilitar data proporcional do dissídio em relação à data de ingresso</CheckboxCmp>
              {DataDissidioOn && <InputCmp value={DataDissidio} OnChange={setDataDissidio} type='month' title='Data de aplicação do dissídio'/>}
            </Flex>
            <Flex justifyContent={'end'} gap={'1rem'}>
              <ButtonCmp VarColor='c6' onClick={onClose}>Voltar</ButtonCmp>
              <ButtonCmp VarColor='Green2' onClick={onPostDissidio}>Aplicar dissídio</ButtonCmp>
            </Flex>
          </FormControl>
        </LoadingContainer>
      </WhiteModal>
    </Modal>
  )
}
